<!-- ======= Hero Section ======= -->
<section class="hero-section" id="hero">

    <div class="wave">

        <svg width="100%" height="355px" viewBox="0 0 1920 355" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Apple-TV" transform="translate(0.000000, -402.000000)" fill="#FFFFFF">
            <path d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,757 L1017.15166,757 L0,757 L0,439.134243 Z" id="Path"></path>
          </g>
        </g>
      </svg>

    </div>

    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 hero-text-image">
                <div class="row">
                    <div class="col-lg-7 text-center text-lg-left">
                        <h1 data-aos="fade-right">Getbetter.io</h1>
                        <p class="mb-5" data-aos="fade-right" data-aos-delay="100">Create your profile and chat with people that understand you. Fight depression, anxiety and other mental issues along with people that share your mindset.</p>
                        <p data-aos="fade-right" data-aos-delay="200" data-aos-offset="-500"><a href="/login" class="btn btn-outline-white">Get started</a></p>
                        <div class="mt-5">
                            <a href='https://play.google.com/store/apps/details?id=com.getbetter_io&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='../../../assets/google-play-badge.png' /></a>

                        </div>
                    </div>
                    <div class="col-lg-5 iphone-wrap">
                        <img src="../../../assets/phone1gb.png" alt="Image" class="phone-1 animated slideInDown" data-aos="fade-right">
                        <img src="../../../assets/phone2gb.png" alt="Image" class="phone-2 animated slideInUp" data-aos="fade-right" data-aos-delay="200">

                    </div>

                </div>
            </div>
        </div>
    </div>

</section>
<!-- End Hero -->

<main id="main">

    <!-- ======= Home Section ======= -->
    <section class="section animated slideInLeft">
        <div class="container">

            <div class="row justify-content-center text-center mb-5">
                <div class="col-md-5" data-aos="fade-up">
                    <h2 class="section-heading">Easy profile creation</h2>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4" data-aos="fade-up" data-aos-delay="">
                    <div class="feature-1 text-center">
                        <div class="wrap-icon icon-1">
                            <img src="../../../assets/gbregister.png" class="steps-image">
                        </div>
                        <h3 class="mb-3">Register</h3>
                        <p>No personal data required. Only email.</p>
                    </div>
                </div>
                <div class="col-md-4" data-aos="fade-up" data-aos-delay="100">
                    <div class="feature-1 text-center">
                        <div class="wrap-icon icon-1">
                            <img src="../../../assets/gbsetup.png" class="steps-image">
                        </div>
                        <h3 class="mb-3">Set up your profile</h3>
                        <p>Choose what issues you have been struggling recently in order to get the best matches.</p>
                    </div>
                </div>
                <div class="col-md-4" data-aos="fade-up" data-aos-delay="200">
                    <div class="feature-1 text-center">
                        <div class="wrap-icon icon-1">
                            <img src="../../../assets/gbchat.png" class="steps-image">
                        </div>
                        <h3 class="mb-3">Start chatting</h3>
                        <p>Algorithm will give you best connections from your country or across the world.</p>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <section class="section animated pt-1 slideInRight">
        <div class="container">

            <div class="row justify-content-center text-center mb-5">
                <div class="col-md-5" data-aos="fade-up">
                    <h2 class="section-heading">Wide disorders choice</h2>
                </div>
            </div>

            <div class="tags-container m-3 pt-2 pb-1 text-center">
                <div class="d-inline" *ngFor="let d of disorders">
                    <mdb-badge class="dbadge m-1 grey lighten-1" pill="true">{{d}}</mdb-badge>
                </div>
            </div>
        </div>
    </section>
</main>